import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/logo-converza.png'


const _hoisted_1 = { class: "h-[25vh] bg-blue-200 w-full p-6" }
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = { class: "flex flex-1 flex-row-reverse justify-start content-center items-center" }

import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'LandingPageHeader',
  setup(__props) {

const routes = ref<{ path: string; name: string }[]>([]);

const router = useRouter();

const goToHome = async () => {
  await router.push('/');
};

const route = useRoute();
const isActive = (path: string) => {
  return route.fullPath === path;
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("img", {
        onClick: goToHome,
        class: "h-10 cursor-pointer",
        src: _imports_0,
        alt: "Ir para página principal"
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "pr-4 ml-10 mr-0 text-lg font-medium hover:underline hover:text-blue-400",
          to: '/login'
        }, {
          default: _withCtx(() => [
            _createTextVNode("Logar")
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(routes.value, (route, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "pr-4 mx-5 first-of-type:mr-0"
          }, [
            _createVNode(_component_router_link, {
              to: route.path,
              class: _normalizeClass(["text-lg font-medium underline-offset-4", {
              'underline text-lg hover:underline font-medium': isActive(route.path),
              'text-blue-950 hover:text-blue-400 hover:underline': !isActive(route.path)
            }])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(route.name), 1)
              ]),
              _: 2
            }, 1032, ["to", "class"])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})